import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { INotificationWaveCreated } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import WaveHeaderFollow, { WaveFollowBtnSize } from "@/components/waves/header/WaveHeaderFollow";
import { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import NotificationHeader from "../subcomponents/NotificationHeader";
export default function NotificationWaveCreated(t0) {
  const $ = _c(27);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.additional_context.wave_id) {
    t1 = {
      queryKey: [QueryKey.WAVE, {
        wave_id: notification.additional_context.wave_id
      }],
      queryFn: async () => await commonApiFetch({
        endpoint: `waves/${notification.additional_context.wave_id}`
      })
    };
    $[0] = notification.additional_context.wave_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: wave
  } = useQuery(t1);
  const {
    isApp
  } = useDeviceInfo();
  const t2 = wave?.chat.scope.group?.is_direct_message ?? false;
  let t3;
  if ($[2] !== isApp || $[3] !== notification.additional_context.wave_id || $[4] !== t2) {
    t3 = getWaveRoute({
      waveId: notification.additional_context.wave_id,
      isDirectMessage: t2,
      isApp
    });
    $[2] = isApp;
    $[3] = notification.additional_context.wave_id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const invitationHref = t3;
  const t4 = notification.related_identity;
  let t5;
  if ($[6] !== wave) {
    t5 = wave && <WaveHeaderFollow wave={wave} subscribeToAllDrops={true} size={WaveFollowBtnSize.SMALL} />;
    $[6] = wave;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== notification.related_identity) {
    t6 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[8] = notification.related_identity;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">invited you to a wave:</span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = wave?.name;
  let t10;
  if ($[14] !== invitationHref || $[15] !== t9) {
    t10 = <Link href={invitationHref} className="tw-text-sm tw-font-medium tw-no-underline tw-text-primary-400 hover:tw-text-primary-300">{t9}</Link>;
    $[14] = invitationHref;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== notification.created_at) {
    t12 = getTimeAgoShort(notification.created_at);
    $[18] = notification.created_at;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t11}{t12}</span>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== notification.related_identity || $[23] !== t10 || $[24] !== t13 || $[25] !== t7) {
    t14 = <div className="tw-w-full"><NotificationHeader author={t4} actions={t7}>{t8}{t10}{t13}</NotificationHeader></div>;
    $[22] = notification.related_identity;
    $[23] = t10;
    $[24] = t13;
    $[25] = t7;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}